import '@/plugins/dayjs';
import '@/styles/utility.scss';
import '@/pt9800/css/app.css';
import '@/styles/vue-cal-styles.css';
import '@/styles/vue-simple-calendar-styles.scss';
import '@/styles/vue-simple-calendar-default-styles.css';
import '@/styles/vue-simple-calendar-dist-styles.css';
import 'vue-cal/dist/vuecal.css';
import PrimeVue from '@NitrexGroup/primevue/config';
import ConfirmationService from '@NitrexGroup/primevue/confirmationservice';
import ToastService from '@NitrexGroup/primevue/toastservice';
import {
  RefreshSPABuild,
} from '@qmulus/frontend-shared/plugin';
import QmulusUi, {
  QTooltip,
} from '@qmulus/ui';
import * as Sentry from '@sentry/vue';
import {
  VueQueryPlugin,
} from '@tanstack/vue-query';
import {
  createApp,
} from 'vue';

import packageInfo from '@/../package.json';
import App from '@/app.vue';
import {
  keycloakAuthenticationHandler,
} from '@/authentication.ts';
import config from '@/config/config.ts';
import {
  i18n,
} from '@/plugins/i18n';
import {
  createPT9800,
} from '@/plugins/pt9800.js';
import router from '@/router';
import store from '@/store';
import {
  applyLocalStorageUserSettingsEarly,
} from '@/store/pinia/custom-user-storage';
import pinia from '@/store/pinia/export.js';
import '@/primevue/filter-service.ts';
import '@/styles/main.scss';
import '@/styles/core-styles.css';
import {
  setPrimeVueStore,
} from '@/utils/primevue.ts';

keycloakAuthenticationHandler.initialize().then(() => {
  const app = createApp(App);

  if (config.VITE_SENTRY_DSN && import.meta.env.MODE === 'production') {
    Sentry.init({
      app,
      dsn: config.VITE_SENTRY_DSN,
      environment: config.VITE_SENTRY_ENVIRONMENT,
      release: `Qmulus@${packageInfo.version}`,
      integrations: [
        Sentry.browserTracingIntegration({
          router,
        }),
        Sentry.replayIntegration(),
      ],
      // will spam A LOT in console
      // debug,

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,

      // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
      // enable if required
      // tracePropagationTargets: [
      //   'local.qmulus.ai',
      //   /^https:\/\/yourserver\.io\/api/,
      // ],

      // Capture Replay for 10% of all sessions,
      // plus for 100% of sessions with an error
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }
  // Load user settings from local storage early to apply language and other settings before the app is mounted
  applyLocalStorageUserSettingsEarly();

  app.use(VueQueryPlugin);
  app.use(router);
  app.use(store);
  app.use(pinia);
  app.use(
    createPT9800({
      store,
      storeKey: 'pt9800',
    }),
  );
  app.use(i18n);
  app.use(QmulusUi, {
    i18n,
  });
  app.use(RefreshSPABuild);

  // primevue
  app.use(PrimeVue);
  app.use(ToastService);
  app.use(ConfirmationService);

  // Setting PrimeVue Store to global properties to make it accessible in components
  setPrimeVueStore(app.config.globalProperties.$primevue);

  app.directive('tooltip', QTooltip);

  app.mount('#app');
});
